<template>
  <div class="emendas-list">
    <div class="row">
      <div class="col-xs-12">
        <button
          type="button"
          class="btn btn-primary btn-voltar"
          @click="$router.back()"
        >
          <font-awesome-icon :icon="'arrow-left'" />
          Voltar
        </button>
        <h1 class="page-header">
          Lista de Processos da Emenda nº {{ numero }}
        </h1>
        <button
          title="Adicionar"
          type="button"
          class="btn btn-default"
          @click="adicionar()"
        >
          <font-awesome-icon :icon="'plus'"></font-awesome-icon>
          Adicionar
        </button>
        <list
          ref="vuetable"
          :show-empty="true"
          title="Lista de processos de pagamento"
          report-title="Processos de pagamento"
          :fields="fields"
          :dados="processos_pagamento"
        >
          <template slot="rowrender" slot-scope="props">
            <button
              title="Editar"
              type="button"
              class="btn btn-primary"
              @click="editar(props.rowData)"
            >
              <font-awesome-icon :icon="'edit'"></font-awesome-icon>
            </button>
            <button
              title="Excluir"
              class="btn btn-danger"
              @click="excluir(props.rowData)"
            >
              <font-awesome-icon :icon="'trash'"></font-awesome-icon>
            </button>
          </template>
        </list>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/request'
import list from '@/components/common/NoApiTable'
import { formatarMoeda } from '@/utils/strings'
import modal from '@/components/common/Modal'

export default {
  inject: ['showConfirm'],
  data() {
    return {
      numero: '',
      codigo_emenda: '',
      processos_pagamento: [],
      fields: [
        {
          name: 'numero_pagamento',
          title: 'Número',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'valor',
          title: 'Valor',
          dataClass: 'align-middle',
          filterable: true,
          callback(value) {
            return formatarMoeda(Number(value))
          }
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-2',
          dataClass: 'text-center'
        }
      ]
    }
  },
  components: {
    list,
    modal
  },
  mounted() {
    const { id } = this.$route.params
    if (id) {
      this.loadEmendaProcessos(id)
    }
  },
  methods: {
    async loadEmendaProcessos(id) {
      const response = await request.get(`emenda/${id}/processos`)
      const emenda = response.data
      this.numero = emenda.numero
      this.codigo_emenda = emenda.id
      this.processos_pagamento = emenda.processos_pagamento
    },
    async adicionar() {
      const codigo_emenda = this.codigo_emenda
      this.$router.push({
        name: 'user_salvar_processospagamento',
        params: { codigo_emenda }
      })
    },
    editar(data) {
      const { id } = data
      this.$router.push({
        name: 'user_salvar_processospagamento',
        params: { id }
      })
    },
    carregarProcessosPagamento() {
      const id = this.codigo_emenda
      request
        .get(`emenda/${id}/processos`, this.formatedProcessosPagamento)
        .then(response => {
          const emenda = response.data
          this.processos_pagamento = emenda.processos_pagamento
        })
        .catch(error => {
          this.$toastr.e(
            'Houve um erro ao carregar a lista de processos de pagamento. Por favor, tente novamente mais tarde.'
          )
        })
    },
    excluir(data) {
      const me = this
      const { id } = data
      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(`processospagamento/${id}`)
            .then(resp => {
              me.$toastr.s('Processo de pagamento removido com sucesso!')
              me.carregarProcessosPagamento()
            })
            .catch(error => {
              console.log(error)
              me.$toastr.e(
                'Houve uma falha ao tentar remover esse item, por favor, tente novamente mais tarde!'
              )
            })
        }
      }

      this.showConfirm(
        'Deseja realmente deletar este item?',
        config
      )
    }
  },
  computed: {
    formatedProcessosPagamento() {
      const { numero_pagamento, valor } = this.processos_pagamento

      return {
        ...this.processos_pagamento
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/emendas-parlamentares/emendas/ListProcessosPagamento.vue